import {
	Download,
	DownloadEvent,
	DownloadQueue,
	DownloadState,
	update,
} from '@/services/Downloads';
import { Component, Prop, Vue } from 'vue-property-decorator';

export interface Colors {
	background: string;
	foreground: string;
}

@Component({})
export class DownloadListenerMixin extends Vue {
	@Prop() protected readonly autoColor?: boolean;
	@Prop() protected readonly autoShow?: boolean;
	@Prop() protected readonly downloadId: unknown;

	protected download: Download | null = null;

	protected get colors(): Colors {
		// These colors combos are simply those that Bootstrap uses in most of its examples for
		// good contrast.

		if (this.download === null) {
			return {
				background: 'warning',
				foreground: 'dark',
			};
		}

		switch (this.download.state) {
			case DownloadState.preparing:
				return {
					background: 'secondary',
					foreground: 'white',
				};

			case DownloadState.downloading:
				return {
					background: 'primary',
					foreground: 'white',
				};

			case DownloadState.downloaded:
				return {
					background: 'success',
					foreground: 'white',
				};

			case DownloadState.failed:
				return {
					background: 'danger',
					foreground: 'white',
				};
		}

		throw new Error('Unreachable code detected');
	}

	protected get show(): boolean {
		return this.download !== null;
	}

	protected created(): void {
		this.download = DownloadQueue.singleton.get(this.downloadId) ?? null;
		DownloadQueue.singleton.addEventListener(update, this.listener);
	}

	protected destroyed(): void {
		DownloadQueue.singleton.removeEventListener(update, this.listener);
	}

	protected listener(event: DownloadEvent): void {
		if (event.download.id === this.downloadId) {
			this.download = event.download;
		}
	}
}
